import { render, staticRenderFns } from "./form.vue?vue&type=template&id=1b3a33b3&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3a33b3')) {
      api.createRecord('1b3a33b3', component.options)
    } else {
      api.reload('1b3a33b3', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=1b3a33b3&", function () {
      api.rerender('1b3a33b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OwnWorkbench/form/form.vue"
export default component.exports